import { Module } from 'vuex';
import { RootState } from '../types';
import { getters } from './_getters';
import { actions } from './_actions';
import { mutations } from './_mutations';
import { UserState } from './types';

const state: UserState = {
    token: '',
    expireTime: 0,
    email: '',
    keepLogin: false,
    customerInfo: null,
    noticeClosed: false,
};

const namespaced: boolean = true;

export const User: Module<UserState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};